import styled from "styled-components";
import { Colors } from "../../../../../assets/styles/StyleTypes";

export const LinksList = styled.ul`
  list-style: none;
  margin: 0;
  padding: 0;
  width: 100%;
  max-height: 100%;
  overflow: hidden;

  @media screen and (max-width: 960px) {
    max-height: 100vh;
    overflow: auto;
  }
`;

export const ListItem = styled.li`
  position: relative;

  & > a,
  & > button {
    border: 1px solid transparent;
    color: ${Colors.HIGH_PURE};
    text-decoration: none;
    display: flex;
    align-items: center;
    gap: 15px;
    height: 50px;
    text-transform: uppercase;
    padding-left: 20px;
    font-size: 14px;
    touch-action: manipulation;
    -webkit-tap-highlight-color: transparent;
    -webkit-touch-callout: none;
    user-select: none;
  }

  & > button {
    width: 100%;
    background: transparent;
    cursor: pointer;
    font-family: inherit;
    text-align: left;
  }

  .active {
    background-color: ${(props) => props.theme.colors.navbarHoverItem};
  }

  &#button-logout {
    margin-top: 15px;
  }

  & svg {
    font-size: 35px;

    &#external {
      font-size: 15px;
      position: absolute;
      top: calc(50% - 7.5px);
      right: 20px;
      cursor: pointer;
      color: #767676;
    }
  }
`;

export const Icon = styled.img`
  width: 30px;
  height: auto;
  @media screen and (max-width: 960px) {
    width: 25px;
  }
`;

export const Divider = styled.li`
  list-style: none;
  margin: 2px 16px 6px;
  border-bottom: 1px solid rgba(248, 249, 250, 0.28);

  &.mobile {
    display: none;
  }

  @media screen and (max-width: 960px) {
    display: none;

    &.mobile {
      display: block;
      width: calc(100% - 32px);
      margin: 6px 16px 14px;
      border-bottom: 1px solid rgba(248, 249, 250, 0.28);
    }
  }
`;
